import * as React from "react";
import { Navigator } from "./Navigator";
import styles from "./styles.module.scss";
import { FaTimes } from "react-icons/fa";
import { ToastContainer } from "react-toastify";
import logo from "../../assets/logo.png";

type NavigationProps = {
  isOpen: boolean;
  onClose: () => void;
  page?: string;
  user?: any;
};

const classNames = (...values: Array<string | false | null | undefined>) =>
  values.filter(Boolean).join(" ");

const CustomNavigation = ({ isOpen, onClose, page, user }: NavigationProps) => {
  return (
    <>
      <ToastContainer />

      <button
        type="button"
        className={classNames(
          styles.backdrop,
          isOpen && styles.backdropVisible,
        )}
        onClick={onClose}
        aria-label="Close navigation"
        tabIndex={isOpen ? 0 : -1}
      />

      <aside
        className={classNames(
          styles.navigation,
          isOpen && styles.navigationOpen,
        )}
        aria-label="Sidebar Navigation"
      >
        <div className={styles.brand}>
          <div className={styles.brandMark}>
            <img src={logo} alt="NMFB OBL Admin" />
          </div>

          <div className={styles.brandCopy}>
            <span className={styles.brandTitle}>NMFB OBL Admin</span>
            <span className={styles.brandSubtitle}>Operations Workspace</span>
          </div>

          <button
            type="button"
            className={styles.mobileClose}
            onClick={onClose}
            aria-label="Close navigation"
          >
            <FaTimes />
          </button>
        </div>

        <Navigator
          onNavigate={onClose}
          page={page}
          role={user?.Roles}
          user={user}
        />
      </aside>
    </>
  );
};

export default CustomNavigation;
